import type { Operation, Server } from "@cloudserver/contracts";
import type { TFunction } from "i18next";

export const SERVER_TABS = [
  "overview",
  "networking",
  "power",
  "rescue",
  "iso",
  "rebuild",
  "change-type",
  "backups",
  "volumes",
  "metrics",
  "autopilot",
  "packages",
  // One tab per installed app whose manifest places `server-tab` (`?tab=app&app=<id>`).
  "app",
  "alerts",
  "delete",
] as const;
export type ServerTab = (typeof SERVER_TABS)[number];

/** What every tab of the server page gets. */
export interface ServerTabProps {
  projectId: string;
  server: Server;
  /** The operation running on this server, if any: other changes wait for it. */
  running: Operation | undefined;
  /** Changes are refused: the caller is a guest or the token is read-only. */
  readOnly: boolean;
  /** Why, in the person's language (`guest_read_only` or `read_only_token`). */
  readOnlyReason: string;
  /** Called with the operation a tab started, so the page reports how it ends. */
  watch: (operationId: string) => void;
}

/** Why a change cannot start now, or null when it can. */
export function blockedReason(props: ServerTabProps, t: TFunction): string | null {
  if (props.readOnly) return props.readOnlyReason;
  if (props.running || props.server.locked) return t("servers.busy");
  return null;
}
